type KPISectionProps = {
  kpis: string[];
};

export function KPISection({ kpis }: KPISectionProps) {
  return (
    <section className="border-y border-white/10 bg-slate-950/90">
      <div className="mx-auto max-w-6xl px-6 py-12">
        <div className="flex flex-wrap items-center justify-center gap-6 text-center text-sm font-medium uppercase tracking-[0.3em] text-emerald-200">
          {kpis.map((kpi) => (
            <div key={kpi} className="flex items-center gap-3 text-slate-200">
              <span className="h-1 w-12 rounded-full bg-emerald-300/70" aria-hidden="true" />
              <span>{kpi}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
